const TECHNICAL_LABELS = {
  verified_seller: 'Vérifié',
  pro_seller: 'Vendeur Pro',
  top_seller: 'Top vendeur',
  fast_shipper: 'Expédition rapide',
  trusted_vendor: 'Fiable',
  awaiting_assignment: 'En attente d’attribution',
  wallet_confirmed: 'Paiement confirmé',
  not_connected: 'Non connecté',
  connected: 'Connecté',
  disconnected: 'Déconnecté',
  pending_payment: 'En attente de paiement',
  paid: 'Payé',
  pickup_in_progress: 'Ramassage en cours',
  picked_up: 'Colis récupéré',
  in_transit: 'En transit',
  at_relay: 'Au point relais',
  out_for_delivery: 'En livraison',
  delivered: 'Livré',
  delivered_with_proof: 'Livré',
  cancelled: 'Annulé',
  delivery_rescheduled: 'Livraison reportée',
  delivery_failed: 'Livraison échouée',
  client_absent: 'Client absent',
  active: 'Actif',
  suspended: 'Suspendu',
  archived: 'Archivé',
  approved: 'Approuvé',
  rejected: 'Rejeté',
  pending: 'En attente',
  expired: 'Expiré',
  processing: 'En traitement',
  failed: 'Échec',
  free: 'Gratuit',
  starter_1m: 'Starter (1 mois)',
  pro_3m: 'Pro (3 mois)',
  business_12m: 'Business (12 mois)',
  credit_added: 'Crédit ajouté',
  delivery_debited: 'Livraison débitée',
  subscription_debited: 'Abonnement débité',
  refund_credit: 'Crédit remboursé',
  admin_adjustment: 'Ajustement admin',
  wallet_credit: 'Portefeuille Coli Noki',
  wallet: 'Portefeuille',
  stripe: 'Carte bancaire',
  manual: 'Paiement manuel',
  mtn_money: 'MTN Mobile Money',
  airtel_money: 'Airtel Money',
  mpesa: 'M-Pesa',
  orange_money: 'Orange Money',
  new_delivery: 'Nouvelle livraison',
  delivery_assigned: 'Livreur assigné',
  delivery_completed: 'Livraison terminée',
  status_update: 'Mise à jour de statut',
  payment: 'Paiement',
  system: 'Système',
  promotion: 'Promotion',
  shopify: 'Shopify',
  woocommerce: 'WooCommerce',
  public_api: 'API publique',
  imported: 'Importee',
  awaiting_validation: 'A valider',
  ready_for_conversion: 'A convertir',
  converted: 'Convertie',
  tracking_active: 'Tracking actif',
  ready_for_pickup: 'Pret pour ramassage',
  tracking_sent: 'Tracking envoye',
};

const ACTION_REQUIRED_LABELS = {
  deliveries_needing_assignment: 'Livraisons à attribuer',
  pending_payment: 'Paiements en attente',
  pending_payments: 'Paiements en attente',
  failed_deliveries: 'Livraisons en échec',
  pending_wallet_recharges: 'Recharges de portefeuille en attente',
  failed_wallet_recharges: 'Recharges de portefeuille en échec',
  kyc_pending: 'KYC en attente',
  payouts_pending: 'Paiements d’affiliation en attente',
  pending_jobs: 'Jobs en attente',
  failed_jobs: 'Jobs en échec',
  email_failures: 'Échecs email',
  integrations_disconnected: 'Intégrations déconnectées',
};

const humanize = (value) => {
  const rawValue = String(value || '').trim();
  if (!rawValue) {
    return '';
  }

  const normalized = rawValue
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

export const formatUiLabel = (value) => {
  const rawValue = String(value || '').trim();
  if (!rawValue) {
    return '';
  }

  return TECHNICAL_LABELS[rawValue] || humanize(rawValue);
};

export const formatBadgeLabel = (value) => formatUiLabel(value);
export const formatDeliveryStatusLabel = (value) => formatUiLabel(value);
export const formatPaymentMethodLabel = (value) => formatUiLabel(value);
export const formatWalletTransactionLabel = (value) => formatUiLabel(value);
export const formatOpsActionLabel = (value) => ACTION_REQUIRED_LABELS[String(value || '').trim()] || formatUiLabel(value);
